export const styles = {
  button: {
    _text: {
      color: 'primary.300',
    },
  },
};
